import { useState } from 'react';
import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const galleryPhotos = [
  {
    id: 1,
    src: `${DATA_BASE_URL}/data/badminton/photos/VARISTY BADMINTON.jpeg`,
    title: 'Varsity Badminton Team',
    description: 'ISM varsity badminton team in action',
  },
  {
    id: 2,
    src: `${DATA_BASE_URL}/data/badminton/photos/IASAS SINGAPORE 25 BADMINTON TEAM ISM.jpg`,
    title: 'IASAS Singapore 2025',
    description: 'ISM team at IASAS international tournament',
  },
  {
    id: 3,
    src: `${DATA_BASE_URL}/data/badminton/photos/BADMINTON MALAYSIA 24.jpg`,
    title: 'IASAS Malaysia 2024',
    description: 'Competing at IASAS Malaysia tournament',
  },
  {
    id: 4,
    src: `${DATA_BASE_URL}/data/badminton/photos/PRE-IASAS BANGKOK MARCH 2025 .JPG`,
    title: 'Thailand Pre-IASAS 2025',
    description: 'Pre-IASAS tournament in Thailand',
  },
  {
    id: 5,
    src: `${DATA_BASE_URL}/data/badminton/photos/BADMINTON SINGAPORE 25.jpg`,
    title: 'Singapore Tournament 2025',
    description: 'Competing in Singapore tournament',
  },
  {
    id: 6,
    src: `${DATA_BASE_URL}/data/badminton/photos/MALAYSIA BADMINTON 2024 LEARNING.JPG`,
    title: 'Malaysia Training 2024',
    description: 'Learning and training in Malaysia',
  },
];

const PhotoGallerySection = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-theme-2)' }}>
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Photo Gallery
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Moments from tournaments, training, and team activities
          </p>
        </div>

        {/* Gallery Grid - Desktop: grid, Mobile: horizontal scroll */}
        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 flex md:flex-none overflow-x-auto gap-6 pb-6 snap-x snap-mandatory scrollbar-hide -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-0 lg:px-0">
          {galleryPhotos.map((photo) => (
            <div
              key={photo.id}
              className="group cursor-pointer flex-shrink-0 w-[85vw] sm:w-[75vw] md:w-auto snap-start"
              onClick={() => setSelectedPhoto(photo)}
            >
              <div className="space-y-3 sm:space-y-4">
                <div className="overflow-hidden rounded-xl">
                  <ImageCard
                    src={photo.src}
                    alt={photo.title}
                    aspectRatio="aspect-video"
                    className="group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="text-center space-y-2">
                  <h3
                    className="text-lg sm:text-xl font-semibold"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {photo.title}
                  </h3>
                  <p
                    className="text-xs sm:text-sm"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {photo.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile scroll hint */}
        <div className="md:hidden text-center mt-6">
          <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
            Swipe to see more photos
          </p>
        </div>

        {/* Lightbox Modal */}
        {selectedPhoto && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
            onClick={() => setSelectedPhoto(null)}
          >
            <div className="relative max-w-7xl w-full">
              {/* Close button */}
              <button
                className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
                onClick={() => setSelectedPhoto(null)}
                aria-label="Close"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Image */}
              <img
                src={selectedPhoto.src}
                alt={selectedPhoto.title}
                className="w-full h-auto rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />

              {/* Caption */}
              <div className="mt-4 text-center" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-2xl font-semibold text-white mb-2">{selectedPhoto.title}</h3>
                <p className="text-gray-300">{selectedPhoto.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PhotoGallerySection;
